/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class FinAiAgentAnalyzeMonitorReviewsConversationIssueNewRoute extends Route {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.analyze.monitor.reviews.conversation.issue-new',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(FinAiAgentAnalyzeMonitorReviewsConversationIssueNewRoute);
